import {
  getAccountApiHelper, 
  postAccountApiHelper,
  patchBaseApiHelper,
  deleteBaseApiHelper
} 
  from '../../common/utils/apiHelpers';


import { formatForPost } from './formHelpers';
import { bugsnagClient, appStore } from '../../index';

// Action Types
export const SAMPLES_REQUEST = 'SAMPLES_REQUEST';
export const SAMPLES_SUCCESS = 'SAMPLES_SUCCESS';
export const SAMPLES_FAILURE = 'SAMPLES_FAILURE';

export const SAMPLE_POST_REQUEST = 'SAMPLE_POST_REQUEST';
export const SAMPLE_POST_SUCCESS = 'SAMPLE_POST_SUCCESS';
export const SAMPLE_POST_FAILURE = 'SAMPLE_POST_FAILURE';

export const SCAFFOLD_NEW_SAMPLE = 'SCAFFOLD_NEW_SAMPLE';

export const INSERT_SAMPLE = 'INSERT_SAMPLE';

export const REMOVE_SAMPLE_REQUEST = 'REMOVE_SAMPLE_REQUEST';
export const REMOVE_SAMPLE_SUCCESS = 'REMOVE_SAMPLE_SUCCESS';
export const REMOVE_SAMPLE_FAILURE = 'REMOVE_SAMPLE_FAILURE';

export const DRAG_MARKER = 'DRAG_MARKER ';
export const DROP_MARKER = 'DROP_MARKER ';
export const SET_ACTIVE_SAMPLEFORM = 'SET_ACTIVE_SAMPLEFORM';
export const SET_ACTIVE_SAMPLEMARKER = 'SET_ACTIVE_SAMPLEMARKER';

export const SUBMISSION_REQUEST = 'SUBMISSION_REQUEST';
export const SUBMISSION_SUCCESS = 'SUBMISSION_SUCCESS';
export const SUBMISSION_FAILURE = 'SUBMISSION_FAILURE';

export const SET_ISNEWSAMPLE_FALSE = 'SET_ISNEWSAMPLE_FALSE';

// Action Creators
function samplesRequest() {
  return {
    type: SAMPLES_REQUEST,
    isFetching: true
  };
}

function samplesSuccess(samples) {
  return {
    type: SAMPLES_SUCCESS,
    samples: samples
  };
}


// Thunks/Async Action Creators
export function getSamples() {
  return dispatch => {
    dispatch(samplesRequest());
    return getAccountApiHelper('/samples')
      .then(response => {
        dispatch(samplesSuccess(response.data));
        return response.data;
      })
      .catch(error => {
        return error.response;
      });
  };
}

// Thunks/Async Action Creators

export function scaffoldNewSample(sampleScaffold) {
  return {
    type: SCAFFOLD_NEW_SAMPLE,
    payload: sampleScaffold
  };
}

export function dragMarker(sampleId) {
  /*
    expect sampleId to be a string with the id of a sample
  */
  return {
    type: DRAG_MARKER,
    sampleId
  };
}

export function dropMarker(marker) {
  /*
    marker should be an object of the following shape:
    {sampleId: float, latitude: float, longitude: string}
  */
  marker['active'] = true;
  return {
    type: DROP_MARKER,
    marker
  };
}

//Single Sample Post Actions

function samplePostRequest(){
  return {
    type: SAMPLE_POST_REQUEST,
    isPosting: true
  };
}

function samplePostSuccess(sample, originalId, isNewSample){
  return {
    type: SAMPLE_POST_SUCCESS,
    isPosting: false,
    sample,
    originalId, 
    isNewSample
  };
}

export function removeSampleRequest() {
  return {
    type: REMOVE_SAMPLE_REQUEST,
    isPosting: true,
  };
}

export function removeSampleSuccess(sampleId) {
  return {
    type: REMOVE_SAMPLE_SUCCESS,
    sampleId
  };
}

export function removeSampleFailure(error) {
  return {
    type: REMOVE_SAMPLE_FAILURE,
    isPosting: false,
    error
  };
}

export function setActiveSampleForm(formId) {
  // expect formId to be a string identifying a form
  return {
    type: SET_ACTIVE_SAMPLEFORM,
    formId
  };
}

export function setActiveSampleMarker(sampleId) {
  return {
    type: SET_ACTIVE_SAMPLEMARKER,
    sampleId
  };
}

function samplePostFailure(error){
  return {
    type: SAMPLE_POST_FAILURE,
    isPosting: false,
    error
  };
}

export function sendSample(sample, sampleId, attempt) {
  const originalSampleId = sample.id || null;
  const isNewSample = sampleId ? false : true;
  const postObject = formatForPost(sample);
  if (appStore.getState().auth.isViewOnly) {
    return () => Promise.resolve({ message: 'view-only' });
  }
  return dispatch => {
    dispatch(samplePostRequest());
    //If sample has been submitted before, send to id endpoint
    if(!isNewSample){
      return patchBaseApiHelper(`/samples/${sampleId}`, postObject)
        .then(response => {
          dispatch(samplePostSuccess(response.data, originalSampleId, isNewSample));
          return {data: response};
        })
        .catch(rejected => {
          // If timeout, try again, but only once. 
          if (rejected.code === 'ECONNABORTED'){
            if (!attempt){
              return dispatch(sendSample(sample, sampleId, 2))
            } else {
              rejected.status = 0
              dispatch(samplePostFailure(rejected));
              return {error: rejected};
            }
          } else { 
            dispatch(samplePostFailure(rejected.response));
            return {error: rejected.response};
          }
        });
    } else {
      //If sample is first time submitting, send to base sample endpoint
      return postAccountApiHelper('/samples', postObject)
        .then(response => {
          dispatch(samplePostSuccess(response.data, originalSampleId, isNewSample));
          return response;
        })
        .catch(rejected => {
          dispatch(samplePostFailure(rejected.response));
          return {error: rejected.response};
        });
    }
  };
}

//Submission Actions
function submissionRequest() {
  return {
    type: SUBMISSION_REQUEST,
    isSubmitting: true
  };
}

function submissionSuccess(submission) {
  return {
    type: SUBMISSION_SUCCESS,
    submission
  };
}

function submissionFailure(error) {
  return {
    type: SUBMISSION_FAILURE,
    error
  };
}
// Thunks/Async Action Creators
export function postSubmission(submissionObject) {
  if (appStore.getState().auth.isViewOnly) {
    return () => Promise.resolve({ message: 'view-only' });
  }
  return dispatch => {
    dispatch(submissionRequest());
    return postAccountApiHelper('/samples/submit', submissionObject)
      .then(response => {
        dispatch(submissionSuccess(response.data));
        return {data: response};
      })
      .catch(rejected => {
        dispatch(submissionFailure(rejected));
        return {error: rejected};
      });
  };
}

export function removeSample(sampleId) {
  if (appStore.getState().auth.isViewOnly) {
    return () => Promise.resolve({ message: 'view-only' });
  }
  return dispatch => {
    dispatch(removeSampleRequest());
    return deleteBaseApiHelper(`/samples/${sampleId}`)
      .then(response => {
        dispatch(removeSampleSuccess(sampleId, response.data));
        return {data: response};
      })
      .catch(rejected => {
        if(rejected.response.status === 404) {
          dispatch(removeSampleSuccess(sampleId, rejected.response));
          return {data: rejected.response.data};
        } else {
          dispatch(removeSampleFailure(rejected.response));
          return {error: rejected.response};
        }
      });
  };
}

export function setIsNewSampleFalse() {
  return {
    type: SET_ISNEWSAMPLE_FALSE
  };
}
